module.exports = __webpack_public_path__ + "img/golftour_mt.e305f922.png";